import { type IBaseDataProvider, type ICollectionParams, type IResourceParams } from './models';
import { CollectionResource, ItemResource } from './resource';

export function createCollectionResource<T>(
    $scope: angular.IScope,
    dataProvider: IBaseDataProvider,
    resourceParams: IResourceParams,
    collectionParams: ICollectionParams,
    collectionParamsTransformer?: (paramsIn: ICollectionParams) => ICollectionParams,
    onStart?: () => void,
    onUpdated?: () => void,
    onLoaded?: (items: T[]) => void,
    onFail?: (msg: string) => void,
    fetchAllItems?: boolean
): CollectionResource<T> {
    const dataResource: CollectionResource<T> = dataProvider.getCollectionResource(resourceParams);
    dataResource.linkCollectionParams(collectionParams);
    dataResource.setCollectionParamsTransformer(collectionParamsTransformer);
    dataResource.setFetchAllItems(!!fetchAllItems);
    if (!onUpdated) {
        dataResource.onUpdated(() => {
            dataResource.reload();
        });
    } else {
        dataResource.onUpdated(onUpdated);
    }
    onStart && dataResource.onStart(onStart);
    onLoaded && dataResource.onLoaded(onLoaded);
    onFail && dataResource.onFail(onFail);
    $scope.$on('$destroy', () => {
        dataResource.close();
    });
    // dataResource.reload();
    return dataResource;
}

export function createItemResource<T>(
    $scope: angular.IScope,
    dataProvider: IBaseDataProvider,
    resourceParams: IResourceParams,
    onStart?: () => void,
    onUpdated?: () => void,
    onLoaded?: (item: T) => void,
    onFail?: (msg: string) => void
): ItemResource<T> {
    const dataResource: ItemResource<T> = dataProvider.getItemResource(resourceParams);
    if (!onUpdated) {
        dataResource.onUpdated(() => {
            dataResource.reload();
        });
    } else {
        dataResource.onUpdated(onUpdated);
    }
    onStart && dataResource.onStart(onStart);
    onLoaded && dataResource.onLoaded(onLoaded);
    onFail && dataResource.onFail(onFail);
    $scope.$on('$destroy', () => dataResource.close());
    return dataResource;
}
